import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { LegalRestrictionEffects } from './store/legal-restriction.effects';
import { legalRestrictionReducer } from './store/legal-restriction.reducer';

@NgModule({
  providers: [
    provideState('legalRestriction', legalRestrictionReducer),
    provideEffects([LegalRestrictionEffects]),
  ],
})
export class LegalRestrictionModule {}
